// A quiet, non-blocking "offline" indicator. It is deliberately NOT a warning
// bar: when the network drops we still show the user's cached mail, so the
// indicator should read as a calm status note ("you're looking at the cache"),
// not an alarm. It's a small neutral pill pinned to the bottom-centre - out of
// the way of the sidebar (left), compose windows + toasts (bottom-right) and
// the top toolbar - and it never intercepts clicks (pointer-events-none).
//
// Subscribes to the shared network state so every route shares one indicator.

import { network } from "../cache/net.js";
import { renderIcons } from "../icons.js";

let mounted = false;

export function mountOfflineBanner() {
  if (mounted) return;
  mounted = true;

  const el = document.createElement("div");
  el.id = "offline-banner";
  el.setAttribute("role", "status");
  el.setAttribute("aria-live", "polite");
  // Hidden resting state: faded out and nudged down. Toggled by the subscriber.
  el.className = [
    "fixed bottom-4 left-1/2 -translate-x-1/2 z-40",
    "flex items-center gap-1.5",
    "px-3 py-1.5 rounded-pill",
    "bg-mail-surface/95 backdrop-blur-sm border border-mail-border-soft shadow-soft",
    "text-[11px] font-medium text-mail-muted",
    "transition-all duration-300 ease-out",
    "opacity-0 translate-y-2 pointer-events-none select-none",
  ].join(" ");
  el.innerHTML = `
    <i data-lucide="cloud-off" class="w-3.5 h-3.5 text-mail-subtle"></i>
    <span>Viewing offline cache</span>
  `;
  document.body.appendChild(el);
  renderIcons(el);

  network.subscribe((state) => {
    if (state === "offline") {
      el.classList.remove("opacity-0", "translate-y-2");
    } else {
      el.classList.add("opacity-0", "translate-y-2");
    }
  });
}
